export default "__VITE_ASSET__wdLRg3R4__"